import { createSlice } from "@reduxjs/toolkit";
import { GetPeriodCapacityDataResponse } from "./periodCapacityData.api";
import { GetPeriodCapacityDataThunk } from "./periodCapacityData.thunk";

export interface PeriodCapacityDataStore {
  capacityData: GetPeriodCapacityDataResponse;
  selectedTime: {
    date: number;
    hour: number;
  };
}

export const InitialPeriodCapacityDataState: PeriodCapacityDataStore = {
  capacityData: { data: [] },
  selectedTime: {
    date: 0,
    hour: 0,
  },
};

const PeriodCapacityDataSlice = createSlice({
  name: "PeriodCapacityDataSlice",
  initialState: InitialPeriodCapacityDataState,
  reducers: {
    setSelectedTime(state, action) {
      state.selectedTime = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(GetPeriodCapacityDataThunk.fulfilled, (state, action) => {
      if (action.payload) {
        state.capacityData = action.payload;
        // TODO: for test, delete after 1 month
        // const { data } = action.payload;
        // state.capacityData = {
        //   data: [
        //     ...data.slice(0, 25),
        //     ...data
        //       .slice(-5)
        //       .map((cap) => ({ ...cap, current_reserved_views: 100000000 })),
        //   ],
        // };
      }
    });
  },
});

export const PeriodCapacityDataActions = PeriodCapacityDataSlice.actions;
export const PeriodCapacityDataReducer = PeriodCapacityDataSlice.reducer;
